<h1 mat-dialog-title class="popup-title w-100">
    Confirm Action
  </h1>
  <div mat-dialog-content class="popup-content">
    Are you sure you want to start auto-sync?</div>
  <div mat-dialog-actions class=" popup-buttons d-flex justify-content-end">
    <button [mat-dialog-close]="true" class=" popup-okbutton btn" (click)="confirm()">Confirm</button>
    <button mat-dialog-close  class=" popup-cancelbutton btn ml-2" (click)="cancel()">Cancel</button>
  </div>